import { createAction } from 'redux-act'

import { MembershipDetail } from './types'

const fetchMembershipInfoStart = createAction('Fetch Membership Info')
const fetchMembershipInfoSuccess = createAction<MembershipDetail>('Fetch Membership Info Success')
const fetchMembershipInfoFail = createAction('Fetch Membership Info fail')

export default {
  fetchMembershipInfoStart,
  fetchMembershipInfoSuccess,
  fetchMembershipInfoFail,
}
